const s = {
  page: { minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: 'Inter, sans-serif', padding: '40px 20px' },
  card: { maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)', padding: '48px' },
  header: { textAlign: 'center' as const, marginBottom: '40px', borderBottom: '2px solid #FF6A3D', paddingBottom: '24px' },
  logo: { fontSize: '28px', fontWeight: 800, color: '#FF6A3D', marginBottom: '8px' },
  subtitle: { color: '#666', fontSize: '14px' },
  h2: { fontSize: '18px', fontWeight: 700, color: '#1a1a1a', marginTop: '32px', marginBottom: '12px' },
  p: { color: '#444', lineHeight: 1.7, fontSize: '15px', marginBottom: '12px' },
  ul: { color: '#444', lineHeight: 1.8, fontSize: '15px', paddingLeft: '20px', marginBottom: '12px' },
  stepList: { listStyle: 'none', paddingLeft: 0, marginBottom: '12px' },
  step: { display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', color: '#444', fontSize: '15px', lineHeight: 1.7 },
  stepNumber: { minWidth: '28px', height: '28px', borderRadius: '50%', backgroundColor: '#FF6A3D', color: '#fff', fontWeight: 700, fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  highlight: { backgroundColor: '#fff4f0', border: '1px solid #FF6A3D', borderRadius: '8px', padding: '16px 20px', marginBottom: '16px' },
  warning: { backgroundColor: '#fff8e1', border: '1px solid #f59e0b', borderRadius: '8px', padding: '16px 20px', marginBottom: '16px', color: '#555', fontSize: '14px' },
  footer: { marginTop: '40px', paddingTop: '24px', borderTop: '1px solid #eee', textAlign: 'center' as const, color: '#999', fontSize: '13px' },
};

export const DeleteAccountPage = () => (
  <div style={s.page}>
    <div style={s.card}>
      <div style={s.header}>
        <div style={s.logo}>EncoreEats</div>
        <div style={{ fontSize: '22px', fontWeight: 700, color: '#1a1a1a', marginBottom: '6px' }}>Eliminación de Cuenta</div>
        <div style={s.subtitle}>Account Deletion · Última actualización: mayo 2026</div>
      </div>

      <p style={s.p}>
        Puede eliminar su cuenta de <strong>EncoreEats</strong> en cualquier momento. A continuación encontrará los pasos para hacerlo y la información sobre lo que ocurre cuando su cuenta es eliminada.
      </p>

      <h2 style={s.h2}>Opción 1: Eliminar desde la aplicación</h2>
      <ul style={s.stepList}>
        {[
          'Abra la aplicación EncoreEats en su dispositivo.',
          'Vaya a su Perfil (ícono de usuario en la parte inferior).',
          'Toque Configuración o Ajustes.',
          'Seleccione "Eliminar cuenta".',
          'Confirme su decisión introduciendo su contraseña.',
          'Su cuenta será eliminada de forma permanente.',
        ].map((text, i) => (
          <li key={i} style={s.step}>
            <span style={s.stepNumber as React.CSSProperties}>{i + 1}</span>
            <span>{text}</span>
          </li>
        ))}
      </ul>

      <h2 style={s.h2}>Opción 2: Solicitar eliminación por correo</h2>
      <p style={s.p}>
        Si no puede acceder a la aplicación, puede solicitar la eliminación de su cuenta enviando un correo a:
      </p>
      <div style={s.highlight}>
        <strong>Correo de soporte:</strong>{' '}
        <a href="mailto:encoreeat@gmail.com" style={{ color: '#FF6A3D', textDecoration: 'none' }}>
          encoreeat@gmail.com
        </a>
        <br />
        <strong>Asunto sugerido:</strong> Solicitud de eliminación de cuenta — [tu correo registrado]
        <br />
        <strong>Incluir:</strong> nombre completo y correo electrónico asociado a la cuenta.
      </div>

      <h2 style={s.h2}>¿Qué ocurre cuando eliminas tu cuenta?</h2>
      <ul style={s.ul}>
        <li>Tu perfil y datos personales serán eliminados permanentemente.</li>
        <li>Tu historial de pedidos dejará de estar disponible.</li>
        <li>Tus direcciones guardadas serán borradas.</li>
        <li>No podrás acceder a la cuenta ni recuperarla una vez eliminada.</li>
        <li>Cualquier saldo o beneficio pendiente se perderá.</li>
      </ul>

      <div style={s.warning}>
        ⚠️ <strong>Esta acción es irreversible.</strong> Una vez eliminada la cuenta, no podremos recuperar sus datos. Si desea pausar el uso de la app, simplemente cierre sesión.
      </div>

      <h2 style={s.h2}>Tiempo de procesamiento</h2>
      <p style={s.p}>
        La eliminación desde la aplicación es inmediata. Las solicitudes por correo serán procesadas en un plazo máximo de <strong>30 días hábiles</strong>. Recibirá una confirmación por correo una vez completado el proceso.
      </p>

      <h2 style={s.h2}>Retención de datos</h2>
      <p style={s.p}>
        Algunos datos pueden ser retenidos por obligaciones legales o fiscales durante el período que establezca la normativa aplicable. Estos datos no serán utilizados para ningún otro fin comercial.
      </p>

      <div style={s.footer}>
        © 2026 EncoreEats. Todos los derechos reservados.
      </div>
    </div>
  </div>
);
